
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/sales-funnels-settings",
      function () {
        return require("private-next-pages/profile/sales-funnels-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/sales-funnels-settings"])
      });
    }
  